<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.7501 5.96017C21.0329 6.26954 20.2524 6.4922 19.4485 6.57892C20.2832 6.08306 20.9082 5.2997 21.2063 4.37579C20.4231 4.8417 19.5651 5.16841 18.6704 5.34142C18.2964 4.94163 17.8442 4.62315 17.3417 4.40581C16.8393 4.18847 16.2975 4.07693 15.7501 4.07813C13.5352 4.07813 11.754 5.87345 11.754 8.07657C11.754 8.38595 11.7915 8.69532 11.8524 8.99298C8.53602 8.81954 5.57821 7.23517 3.6118 4.80938C3.2535 5.42137 3.06574 6.1182 3.06805 6.82735C3.06805 8.21485 3.77352 9.43829 4.8493 10.1578C4.21533 10.1329 3.5962 9.9586 3.04227 9.64923V9.69845C3.04227 11.6414 4.41571 13.2516 6.24618 13.6219C5.90249 13.7112 5.54893 13.7568 5.19384 13.7578C4.93368 13.7578 4.68759 13.732 4.43915 13.6969C4.9454 15.2813 6.41962 16.432 8.17508 16.4695C6.80165 17.5453 5.08134 18.1781 3.21337 18.1781C2.87821 18.1781 2.56884 18.1664 2.24774 18.1289C4.01962 19.2656 6.12196 19.9219 8.38602 19.9219C15.736 19.9219 19.7579 13.8328 19.7579 8.54767C19.7579 8.37423 19.7579 8.20079 19.7462 8.02735C20.5243 7.45782 21.2063 6.75235 21.7501 5.96017Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'Twitter' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
